import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
const rotatingWords = ['Reclutamiento', 'Selección', 'Búsqueda de Talento', 'Consultoría de RR.HH.'];
export function Hero() {
  const [currentWordIndex, setCurrentWordIndex] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentWordIndex(prev => (prev + 1) % rotatingWords.length);
    }, 3000);
    return () => clearInterval(interval);
  }, []);
  return <section className="relative min-h-screen flex items-center justify-center px-6 py-32 overflow-hidden" data-id="element-121">
      {/* Clean light background */}
      <div className="absolute inset-0 bg-gradient-to-br from-slate-50 via-gray-50 to-slate-100" data-id="element-122"></div>

      {/* Background image in pure grayscale - happy diverse team */}
      <div className="absolute inset-0" data-id="element-123">
        <img src="https://images.unsplash.com/photo-1543269865-cbf427effbad?w=1920&q=80" alt="Equipo diverso colaborando felizmente en ambiente laboral amigable" className="w-full h-full object-cover opacity-30 grayscale" data-id="element-124" />
        <div className="absolute inset-0 bg-gradient-to-br from-white/70 via-white/50 to-white/70" data-id="element-125"></div>
      </div>

      {/* Subtle decorative elements in grayscale tones */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none" data-id="element-126">
        <motion.div animate={{
        y: [0, -20, 0],
        x: [0, 15, 0]
      }} transition={{
        duration: 10,
        repeat: Infinity,
        ease: 'easeInOut'
      }} className="absolute top-20 right-20 w-96 h-96 bg-slate-200/15 rounded-full blur-3xl" data-id="element-127"></motion.div>
        <motion.div animate={{
        y: [0, 20, 0],
        x: [0, -15, 0]
      }} transition={{
        duration: 12,
        repeat: Infinity,
        ease: 'easeInOut'
      }} className="absolute bottom-20 left-20 w-96 h-96 bg-gray-200/15 rounded-full blur-3xl" data-id="element-128"></motion.div>
      </div>

      <div className="relative max-w-5xl mx-auto text-center z-10" data-id="element-129">
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="text-5xl md:text-7xl font-bold text-slate-900 mb-6 leading-tight" style={{
        fontFamily: 'Poppins, sans-serif',
        letterSpacing: '-0.02em'
      }} data-id="element-130">
          Acompañamos Personas. Impulsamos Equipos.
        </motion.h1>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.1,
        ease: 'easeOut'
      }} className="text-2xl md:text-4xl font-bold text-purple-700 mb-8 h-12" style={{
        fontFamily: 'Poppins, sans-serif'
      }} data-id="element-131">
          <AnimatePresence mode="wait" data-id="element-132">
            <motion.span key={currentWordIndex} initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            y: -20
          }} transition={{
            duration: 0.5
          }} data-id="element-133">
              {rotatingWords[currentWordIndex]}
            </motion.span>
          </AnimatePresence>
        </motion.div>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2,
        ease: 'easeOut'
      }} className="text-xl md:text-2xl text-slate-700 mb-12 max-w-3xl mx-auto leading-relaxed" data-id="element-134">
          Acompañamos cada etapa con cercanía y compromiso, creando experiencias transformadoras. Nos aseguramos que cada encuentro tenga sentido tanto para el cliente como para el candidato.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4,
        ease: 'easeOut'
      }} className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-135">
          <motion.a href="#contacto" whileHover={{
          scale: 1.03
        }} whileTap={{
          scale: 0.98
        }} className="group inline-flex items-center justify-center px-8 py-4 bg-gradient-to-r from-purple-700 to-purple-800 text-white font-semibold rounded-xl shadow-lg shadow-purple-700/30 hover:shadow-xl hover:shadow-purple-700/40 transition-all duration-300" data-id="element-136">
            Busco talento
            <ArrowRightIcon className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-137" />
          </motion.a>

          <motion.a href="#empleo" whileHover={{
          scale: 1.03
        }} whileTap={{
          scale: 0.98
        }} className="inline-flex items-center justify-center px-8 py-4 bg-white text-slate-700 font-semibold rounded-xl border-2 border-slate-300 hover:border-purple-700 hover:text-purple-700 shadow-md hover:shadow-lg transition-all duration-300" data-id="element-138">
            Busco empleo
          </motion.a>
        </motion.div>
      </div>
    </section>;
}